var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-descriptions',{attrs:{"direction":"vertical","column":3,"border":""}},_vm._l((_vm.METMonitorList),function(v,i){return _c('el-descriptions-item',{key:i,attrs:{"contentStyle":{ 'text-align': 'center', color: '#28CCCB' },"labelStyle":{ 'text-align': 'center' },"label":v.name}},[_vm._v(_vm._s(v.value))])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }